import { CartLinesUpdateEvent } from '@shopify/events';

class WiriCartGift extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.openButton = this.querySelector('[data-gift-open]');
    this.panel = this.querySelector('[data-gift-panel]');
    this.submitButton = this.querySelector('[data-gift-submit]');
    this.closeButton = this.querySelector('[data-gift-close]');
    this.status = this.querySelector('[data-gift-status]');
    this.choice = this.querySelector('[data-gift-choice]');
    this.note = this.querySelector('[data-gift-note]');

    this.openButton.addEventListener('click', () => {
      this.panel.hidden = false;
      this.openButton.setAttribute('aria-expanded', 'true');
      this.choice.focus();
    });

    this.closeButton.addEventListener('click', () => {
      this.closePanel();
      this.openButton.focus();
    });

    this.submitButton.addEventListener('click', () => this.addGift());
  }

  closePanel() {
    this.panel.hidden = true;
    this.openButton.setAttribute('aria-expanded', 'false');
  }

  async addGift() {
    if (this.busy || !this.dataset.variantId) return;

    this.busy = true;
    this.openButton.disabled = true;
    this.submitButton.disabled = true;
    this.closeButton.disabled = true;
    this.status.hidden = false;
    this.status.textContent = 'Agregando envoltorio…';

    let deferred;
    let added = false;
    let completed = false;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const variantId = this.dataset.variantId;
      const properties = { Envoltura: this.choice.value };
      const note = this.note.value.trim();

      if (note) {
        properties['Instrucciones para envolver'] = note;
      }

      const sectionIds = [
        ...new Set(
          Array.from(document.querySelectorAll('cart-items-component'))
            .map((element) => element.dataset.sectionId)
            .filter(Boolean)
        )
      ];

      deferred = CartLinesUpdateEvent.createPromise();
      deferred.promise.catch(() => {});

      this.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: variantId, quantity: 1 }],
          promise: deferred.promise
        })
      );

      const payload = {
        items: [{ id: Number(variantId), quantity: 1, properties }]
      };

      if (sectionIds.length) {
        payload.sections = sectionIds.join(',');
      }

      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description || result.message || 'No se pudo agregar.'
        );
      }

      added = true;

      const cartItems = document.querySelector('cart-items-component');
      let cart;

      if (cartItems) {
        await customElements.whenDefined('cart-items-component');
      }

      if (cartItems && typeof cartItems.fetchCartData === 'function') {
        cart = await cartItems.fetchCartData();
      } else {
        const cartResponse = await fetch(root + 'cart.js', {
          headers: { Accept: 'application/json' }
        });

        if (!cartResponse.ok) {
          throw new Error('No se pudo actualizar el carrito.');
        }

        cart = await cartResponse.json();
      }

      this.closePanel();
      this.note.value = '';
      this.choice.selectedIndex = 0;
      this.status.textContent = '¡Envoltorio agregado!';

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'wiri-cart-gift',
          sourceId: 'wiri-cart-gift',
          itemCount: 1,
          sections: result.sections,
          didError: false
        }
      });

      completed = true;
    } catch (error) {
      deferred?.reject(error);

      this.status.textContent = added
        ? 'El envoltorio se agregó, pero no pudimos actualizar la vista. Recarga la página para verlo; no lo agregues otra vez.'
        : error.message || 'No se pudo agregar. Intenta nuevamente.';
    } finally {
      this.busy = false;
      const needsReload = added && !completed;
      this.openButton.disabled = needsReload;
      this.submitButton.disabled = needsReload;
      this.closeButton.disabled = false;
    }
  }
}

if (!customElements.get('wiri-cart-gift')) {
  customElements.define('wiri-cart-gift', WiriCartGift);
}
